'use strict'
import React from 'react'
import PropTypes from 'prop-types'
import metrics from '../lib/metrics.js'
import { withTranslation as translate } from 'react-i18next'

class Zendesk extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    console.log('componentDidMount')
    this.showChat();
    this.uglyButton = false
  }
  initConfig () {
    this.settings = (typeof (this.props.state.zendeskStr) === 'string') ? JSON.parse(this.props.state.zendeskStr) : {};
  }
  saveConfig () {
    this.props.onZendeskSave(JSON.stringify(this.settings))
	}
	setConfig (key, value) {
		this.settings[key] = value;
	}
  getConfig (key, optional_default_value) {
		if (typeof (this.settings[key]) === 'undefined') {
			if (typeof (optional_default_value) !== 'undefined') {
				this.setConfig(key, optional_default_value);
				this.saveConfig();
				return optional_default_value;
			}
			else {
				return false;
			}
		}
		else {
			return this.settings[key];
		}
	}
  fixOnShow() {
    const launcherObj = (
      document.getElementById('launcher') && 
      document.getElementById('launcher').contentDocument
    ) ? document.getElementById('launcher').contentDocument : undefined
    let _this = this
    if (launcherObj) {
      launcherObj.addEventListener('click',function() {
        _this.setConfig('visibility','show')
        _this.saveConfig()
      })
    }
  }
  hideChat() {
    console.log('show chat');
    if(typeof($zopim) === 'function' && typeof($zopim.livechat) !== 'undefined') {
      $zopim.livechat.window.hide();
      if(!this.uglyButton) {
        const iframes = document.getElementsByTagName('iframe')
        const iframes_c = iframes.length
        for(let i = 0;i<iframes_c;i++) {
          if(iframes[i].getAttribute('data-test-id') === 'ChatWidgetButton-iframe') {
            this.uglyButton = iframes[i];
          }
        }
      }
      if(this.uglyButton) {
        this.uglyButton.style.display = 'none';
      }
    }
  }
  showChat() {
    console.log('show chat');
    const delay = (this.props.delay) ? parseInt(this.props.delay) : 0;
    this.initConfig();
    let _this = this;
    if(delay > 1) {
      const d1 = Math.min(3600,parseInt(delay/2))
      setTimeout(function() {
        if(typeof($zopim) === 'function' && typeof($zopim.livechat) !== 'undefined') {
          if($zopim.livechat.window.getDisplay()) {
            if(_this.getConfig('visibility') === 'hide') {
              console.log('user wants to hide ZD, do so')
            }
            else  {
              console.log('Dont hide it as user havent requested it')
            }            
            console.log('Zendesk did previously hide at this point')
            // _this.hideChat();
          }
          else {
          }
        }
      },d1)
    }
    setTimeout(function(){
      console.log('Zendesk is shown if status is online')
      if(typeof($zopim) === 'function' && typeof($zopim.livechat) !== 'undefined') {
        console.log('Zendesk lib initialized')
        $zopim.livechat.setOnStatus(function(status){
          if(status !== 'offline') {
            console.log('status is online');
            if(_this.getConfig('visibility') !== 'hide') {
              console.log('show because visibility not hide');
              $zopim.livechat.window.show();
            }
            else {
              if($zopim.livechat.window.getDisplay()) {
                console.log('hide because visibility is hide');
                _this.hideChat()
              }
            }
          }
          else {
            console.log('chat is no longer in online mode because no agent is available, will continue offline')
            //_this.hideChat()
          }
        })
        $zopim.livechat.setOnChatStart(function(status) {
          metrics.trackZendeskChat();
        })
        $zopim.livechat.window.onHide(function(status) {
          _this.setConfig('visibility','hide');
          _this.saveConfig();
        });
        _this.fixOnShow();
        const avatar = require('../images/zendesk/logo-100p.png');
        $zopim.livechat.concierge.setAvatar(avatar);
        $zopim.livechat.concierge.setName('Handiscover');
      }
    },delay);

  }
  render() {
    return (
      <div></div>
    )
  }
}
export default translate()(Zendesk)
